'use client';
import React from 'react';
import {
  BZ_CONTACT_EMAIL,
  BZ_CONTACT_PHONE,
  BZ_CONTACT_PHONE_HREF,
  BZ_IFRAME_LOGIN_SITE,
  BZ_LOGIN_NEXT,
  BZ_STRIPE_KEY,
  BZ_REGISTER_NEXT,
} from './contact';
import { Slug } from './entity';

export interface BenzingaProps {
  contactEmail: string;
  contactPhoneNumber: string;
  contactPhoneNumberHREF: string;
  iFrameLoginURL: URL;
  loginNextURL: URL;
  loginRegisterURL: URL;
  slug: Slug;
  stripePublishableKey: string;
}

export const BenzingaContext = React.createContext<BenzingaProps>({
  contactEmail: BZ_CONTACT_EMAIL,
  contactPhoneNumber: BZ_CONTACT_PHONE,
  contactPhoneNumberHREF: BZ_CONTACT_PHONE_HREF,
  iFrameLoginURL: new URL(BZ_IFRAME_LOGIN_SITE),
  loginNextURL: new URL(BZ_LOGIN_NEXT),
  loginRegisterURL: new URL(BZ_REGISTER_NEXT),
  slug: {},
  stripePublishableKey: BZ_STRIPE_KEY,
});

export type BenzingaContextType = React.ContextType<typeof BenzingaContext>;

export const BenzingaContextProvider: React.FC<React.PropsWithChildren<Partial<BenzingaProps>>> = React.memo(props => {
  const iFrameURL = React.useMemo(() => new URL(BZ_IFRAME_LOGIN_SITE), []);

  return (
    <BenzingaContext.Provider
      value={{
        contactEmail: props.contactEmail ?? BZ_CONTACT_EMAIL,
        contactPhoneNumber: props.contactPhoneNumber ?? BZ_CONTACT_PHONE,
        contactPhoneNumberHREF: props.contactPhoneNumberHREF ?? BZ_CONTACT_PHONE_HREF,
        iFrameLoginURL: props.iFrameLoginURL ?? iFrameURL,
        loginNextURL: props.loginNextURL ?? new URL(BZ_LOGIN_NEXT),
        loginRegisterURL: props.loginRegisterURL ?? new URL(BZ_REGISTER_NEXT),
        slug: props?.slug ?? {},
        stripePublishableKey: props.stripePublishableKey ?? BZ_STRIPE_KEY,
      }}
    >
      {props.children}
    </BenzingaContext.Provider>
  );
});

BenzingaContextProvider.displayName = 'BenzingaContextProvider';
